import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M50 977.362a2 2 0 0 0-2 2v21H27a2 2 0 1 0 0 4h21v21a2 2 0 1 0 4 0v-21h21a2 2 0 1 0 0-4H52v-21a2 2 0 0 0-2-2",
      overflow: "visible",
      style: {"text-indent":"0","text-transform":"none","direction":"ltr","block-progression":"tb","baseline-shift":"baseline","color":"#000"},
      transform: "matrix(2 0 0 2 -50 -1954.724)"
    }, null, -1)
  ])))
}
export default { render: render }